import * as endpoints from '@App/constants/endpoints';
import interceptor    from '../interceptor';
import { get }        from '../util';
import { post }       from '../util';
import { put }        from '../util';
import { del }        from '../util';

const MEDICALRECORD = 'medicalrecords';
const ATTENDANCE    = 'attendance';
const GROUP         = 'group';
const SECTIONS      = 'sections';
const RELEASE       = 'release';

const groupUrl = () => `${endpoints.API_MEDICALRECORD}/${MEDICALRECORD}/${ATTENDANCE}/${GROUP}`;

//#region [GET]
export const getAttendanceGroups = async ({ header, status, dateStart, dateEnd, patient }) => {
  let pathUrl = groupUrl();

  const queryParams = new URLSearchParams();

  if (status) queryParams.append('status', status);
  if (dateStart) queryParams.append('dateStart', dateStart);
  if (dateEnd) queryParams.append('dateEnd', dateEnd);
  if (patient) queryParams.append('patient', patient);

  if ([...queryParams].length) {
    pathUrl += `?${queryParams.toString()}`;
  }

  const axios = interceptor(header);
  return await get(axios, pathUrl);
};

export const getAttendanceGroupById = async ({ header, medicalRecordsAttendanceGroupId }) => {
  const axios = interceptor(header);
  return await get(axios, `${groupUrl()}/${medicalRecordsAttendanceGroupId}`);
};
//#endregion

//#region [POST]
export const postAttendanceGroup = async ({ header, params }) => {
  const axios = interceptor(header);
  return await post(axios, groupUrl(), params);
};

export const postAttendanceGroupSections = async ({ header, params, medicalRecordsAttendanceGroupId }) => {
  const axios = interceptor(header);
  return await post(axios, `${groupUrl()}/${medicalRecordsAttendanceGroupId}/${SECTIONS}`, params);
};
//#endregion

//#region [PUT]
export const putAttendanceGroupRelease = async ({ header, params, medicalRecordsAttendanceGroupId }) => {
  const axios = interceptor(header);
  return await put(axios, `${groupUrl()}/${medicalRecordsAttendanceGroupId}/${RELEASE}`, params);
};
//#endregion

//#region [DELETE]
export const delAttendanceGroup = async ({ header, medicalRecordsAttendanceGroupId }) => {
  const axios = interceptor(header);
  return await del(axios, `${groupUrl()}/${medicalRecordsAttendanceGroupId}`);
};
//#endregion
